const processOrderProducts = (headers, list, payload, transData) => {
  let getHeaders = ''
  let getContent = ''
  for (let i = 0; i < headers.length; i++) {
    if (headers[i].value === 'qty' || headers[i].value === 'receivedqty') getHeaders += `<th class="th-fontsize text-right" width="${headers[i].width}">${headers[i].text}</th>`
    else getHeaders += `<th class="th-fontsize" width="${headers[i].width}">${headers[i].text}</th>`
  }
  for (let j = 0; j < list.length; j++) {
    let count = 0
    getContent += '<tr>'
    if (count === 0) {
      getContent += `<td class="th-fontsize">${list[j]['productnumber'] || ''} ${list[j]['productname'] || ''}</td>`
      getContent += `<td class="th-fontsize text-right">${list[j]['qty'] || ''}</td>`
    }
    if (list[j].pickedorders && list[j].pickedorders.length === 0) {
      getContent += '<td class="th-fontsize"></td><td class="th-fontsize"></td>'
      getContent += '</tr>'
    }
    for (let k = 0; k < list[j].pickedorders.length; k++) {
      if (count !== 0) {
        getContent += '<td class="th-fontsize"></td><td class="th-fontsize"></td>'
      }
      getContent += `<td class="th-fontsize">${list[j].pickedorders[k]['batchnumber'] || ''}</td>`
      getContent += `<td class="th-fontsize">${list[j].pickedorders[k]['locationname'] || ''}</td>`
      getContent += '</tr>'
      count++
    }
  }
  return content(getHeaders, getContent, payload, transData)
}
const content = (headers, content, payload, transData) => btoa(unescape(encodeURIComponent(`<!DOCTYPE html>
<html>
  <head>
    <meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css">
    <style>
    .footer {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      text-align: center;
    }
    tbody tr { page-break-inside:avoid; }
    tbody tr td { word-break: break-word; }
    .table-condensed>tbody>tr>td, .table-condensed>tbody>tr>th, .table-condensed>tfoot>tr>td, .table-condensed>tfoot>tr>th, .table-condensed>thead>tr>td, .table-condensed>thead>tr>th {
      padding: 2.5px !important;
    }
    </style>
  </head>
  <body>
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-6">
        <img class="img-responsive" height="180" width="180" src="https://kilabapi.apphouse.no/kilab_logo.png" alt="kilab">
      </div>
      <div class="col-xs-6 pull-right">
        <h5><b>${transData.type}:</b> ${payload.type}</h5>
      </div>
      <div class="col-xs-12">
        <table style="width: 100%">
          <tr>
            <th>${transData.number}:</th>
            <td>${payload.number}</td>
            <th>${transData.warehouse}:</th>
            <td>${payload.warehousename || ''}</td>
          </tr>
          <tr>
            <th width="15%">${transData.date}:</th>
            <td width="10%">${payload.orderdate || ''}</td>
            <th width="10%">${transData.comments}:</th>
            <td width="60%">${payload.comments || ''}</td>
          </tr>
        </table>
      </div>
      <div class="col-xs-12" style="margin-top: 4px;">
        <table class="table table-condensed" style="width: 100%">
          <tbody>
            <tr>
              ${headers}
            </tr>
            ${content}
          </tbody>
        </table>
      </div>
    <div class="col-xs-6"></div>
    </div>
  </div>
</body>
</html>`)))
export default processOrderProducts
